import Link from "next/link";
import { useRouter } from "next/router";

export function ShindanFloatingButton() {
  const router = useRouter();

  if (router.pathname === "/shindan") return null;

  return (
    <Link href="/shindan?from=floating">
      <a className="fixed right-4 bottom-6 z-50 flex items-center gap-2 rounded-full bg-[#0073BF] px-5 py-3 text-sm font-bold text-white shadow-lg transition-transform hover:scale-105 active:scale-95">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7l10 5 10-5-10-5z" />
          <path d="M2 17l10 5 10-5" />
          <path d="M2 12l10 5 10-5" />
        </svg>
        AI活用度診断
      </a>
    </Link>
  );
}
